import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "v-divider",
    style: _vm.styles,
    attrs: {
      "role": "separator"
    }
  }, [_c('div', {
    staticClass: "v-divider__hr"
  }), _vm._v(" "), _vm.$slots.default ? [_c('span', {
    staticClass: "v-divider__text"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "v-divider__hr"
  })] : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-66e5293a_0", {
    source: ".v-divider[data-v-66e5293a]{align-items:center;color:var(--c-color);display:flex;position:relative}.v-divider__hr[data-v-66e5293a]{border:none;border-top-width:var(--c-thickness);border-top-style:solid;border-top-color:currentColor;flex-grow:1}.v-divider__text[data-v-66e5293a]{color:var(--c-text-color);font-size:1.125rem;font-weight:700;font-family:var(--g-font-body-family);padding:0 1rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-66e5293a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Divider = __vue_component__;
export { Divider as default };